import { useEffect, useState } from "react";
import { config, ServiceTranslation, SlamaRequestTypes } from "../../utils/constants";
import { getLayoutDirection, isArabic, isWebsiteCheck } from "../../utils/util";
import { fetchTranslationData } from "../../services/translation/translation";
import DirhamSymbol from "../../common/DirhamSymbol";

const PaymentStatus = (props) => {
  const { amount, paymentstatus, trnNumber, refNumber, servCode, serviceLanguage } = props;

  const [translationMap, setTranslationMap] = useState({});
  const [serviceName, setServiceName] = useState("");
  const [desc, setDesc] = useState("");
  const [localLang, setLocalLang] = useState("");

  useEffect(() => {
    let lang = serviceLanguage.split("-")[0];
    setLocalLang(lang);
    fetchTranslationData(ServiceTranslation.Payment, lang).then((result) => {
      setTranslationMap(result || {});
    });
    sessionStorage.removeItem('redirectedFromPayment');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (localLang) {

    }
  }, [localLang]);

  useEffect(() => {
    if (Object.keys(translationMap).length > 0) {
      if (servCode === SlamaRequestTypes.sickLeaveApplication) {
        setServiceName(translationMap?.slaServiceName || "");
        setDesc(translationMap?.slaServiceNameDesc || "");
      } else if (servCode === SlamaRequestTypes.medicalReportRequest) {
        setServiceName(translationMap?.mrServiceName || "");
        setDesc(translationMap?.mrServiceNameDesc || "");
      } else if (servCode === SlamaRequestTypes.healthCardRenewal || servCode === "NPS") {
        setServiceName(translationMap?.rhcServiceName || "");
        setDesc(translationMap?.rhcServiceNameDesc || "");
      }
    }
  }, [translationMap, servCode]);

  let backUrl = "";


  const isCancelled = paymentstatus.toLowerCase().includes("cancelled") || paymentstatus.toLowerCase().includes("failure");
  const isSuccess = paymentstatus.toLowerCase().includes("success");

  // if (isSuccess) {
  //     setItemWithExpiry("slaPaymentStatus", "success", 45000);
  // } else if (isCancelled) {
  //     setItemWithExpiry("slaPaymentStatus", "cancelled", 45000);
  // } else {
  //     setItemWithExpiry("slaPaymentStatus", "initiated", 45000);
  // }

  let isWebsite = isWebsiteCheck();
  if (servCode === SlamaRequestTypes.sickLeaveApplication) {
    backUrl = `${config.mobileBaseUrl}${config.slaMobileMyChatFdi}`;

    if (isWebsite) {
      backUrl = `${config.myChartBaseUrl}${config.slaWebMyChatFdi}`;
    }

  } else if (servCode === SlamaRequestTypes.medicalReportRequest) {
    backUrl = `${config.mobileBaseUrl}${config.mrMobileMyChatFdi}`;

    if (isWebsite) {
      backUrl = `${config.myChartBaseUrl}${config.mrWebMyChatFdi}`;
    }

  } else if (servCode === SlamaRequestTypes.healthCardRenewal || servCode === "NPS") {
    backUrl = `${config.mobileBaseUrl}${config.hciMobileMyChatFdi}`;

    if (isWebsite) {
      backUrl = `${config.myChartBaseUrl}${config.hciWebMyChartFdi}`;
    }

  }

  return (
    <div className={` custombody_color ${getLayoutDirection(localLang)}`}>
            <section
        className="w-100 clearfix RenewCoveragePlanSection PaymentConfirmationBx"
        id="CoverPlanActive">
        
                <div className="Payment_Confirmation_Box">
                    <h6 className="MainTitleOne">{translationMap?.paymentConfirmation || "Payment Confirmation"}</h6>
                    <div className="Payment_inner_wrap">
                        {isSuccess &&
            <div className="AlertInnerBox GreenAlertInnerBox fade show">
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">
                                        <span className="material-symbols-outlined">check_circle</span>
                                    </a>
                                </div>
                                <div className="alert_text">
                                    <h6>
                                        <p>{translationMap?.payment_accepted}</p>
                                    </h6>
                                    <p className="number_txt">
                                        <p>{desc}</p>
                                    </p>
                                </div>
                            </div>
            }
                        {isCancelled &&
            <div className="AlertInnerBox YellowAlertInnerBox fade show">
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">
                                        <span className="material-symbols-outlined">warning</span>
                                    </a>
                                </div>
                                <div className="alert_text">
                                    <h6>
                                        <p>{translationMap?.paymentNotProcessed}</p>
                                    </h6>
                                    <p className="number_txt">
                                        <p>{translationMap?.tryAgain}</p>
                                    </p>
                                </div>
                            </div>
            }
                        <div className="payment_detail_box">
                            <p className="blod_title">{translationMap?.paymentDetails || "Payment Details"}</p>
                            <ul>
                                <li>
                                    <p>
                                        {translationMap?.amount || "Amount:"}
                                        <span style={{ display: "inline-flex", alignItems: "center" }}>
                                          {isArabic() ?
                                            <><span>{amount}</span><DirhamSymbol width={10} height={11} marginTop={-2} /></> :
                                            <><DirhamSymbol width={10} height={11} marginTop={-2} /><span>{amount}</span></>
                                          }
                                        </span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {translationMap?.requestNumber || "Request Number:"}
                                        <span>{refNumber}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {translationMap?.transactionNumber || "Transaction Number:"}
                                        <span>{trnNumber}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className="pay_btn_box">
                            <a href={backUrl} className="bluetrans_btn_link">
                                {`${translationMap?.backTo || "Back to"} ${translationMap?.[serviceName] || serviceName || "Service"}`}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>);

};

export default PaymentStatus;